import { css } from '@emotion/react';

import { space } from '../shared/styles';
import {
  LandtrustPlusDark,
  LandtrustPlusLight,
  LandtrustStandardDark,
  LandtrustStandardLight,
} from './components';
import { LogoTheme, LogoVariant } from './Logo.types';

export type LogoProps = {
  /**
   * Logo variant ('standard' or 'plus')
   */
  variant: LogoVariant;
  /**
   * Color theme ('light' or 'dark')
   */
  theme?: LogoTheme;
  /**
   * Size of the logo using space tokens
   */
  size?: keyof typeof space;
  /**
   * Additional CSS class names
   */
  className?: string;
  /**
   * Click event handler
   */
  onClick?: () => void;
};

const logoStyles = (size: keyof typeof space) => css`
  width: ${space[size]};
  height: auto;
  display: block;
`;

const Logo = ({
  variant,
  theme = 'light',
  size = 50,
  className,
  ...rest
}: LogoProps) => {
  const getLogoComponent = () => {
    if (variant === 'standard' && theme === 'light') {
      return LandtrustStandardLight;
    }

    if (variant === 'standard' && theme === 'dark') {
      return LandtrustStandardDark;
    }

    if (variant === 'plus' && theme === 'light') {
      return LandtrustPlusLight;
    }

    if (variant === 'plus' && theme === 'dark') {
      return LandtrustPlusDark;
    }

    return LandtrustStandardLight; // fallback
  };

  const LogoComponent = getLogoComponent();

  return (
    <LogoComponent css={logoStyles(size)} className={className} {...rest} />
  );
};

export default Logo;
